<template>
  <div class="row">
    <div class="col-sm-3 col-lg-3 tablet-full-width">
      <filterservice
        :apiResponse="info"
        :filter="getData"
        @depArr="depArr = $event"
        @categoryArr="cateArr = $event"
        @sectorArr="sectorArr = $event"
        @subArr="subArr = $event"
        @healthArr="healthArr = $event"
        @funcArr="funcArr = $event"
        @ruleArr="ruleArr = $event"
        @tarckApplyFilter="tarckApplyFilter = true"
        @SortType="SortType = $event"
        @assignToMeAction="assignToMe = $event"
        :filterClicked="tarckApplyFilter"
        :PageType="PageType"
        :surveys="surveys"
        v-if="info"
        :sectorLab="SectorLabel"
        :categoryLab="CategoryLabel"
        :productLab="ProductsLabel"
        :functionsLab="FunctionsLabel"
        :searchLab="SearchLabel"
        :CategoriesOfRules="CategoriesOfRules"
        @datestart="datestart = $event"
        @dateend="dateend = $event"
        @resetDate="resetDate = $event"
        :ClearDateFilter="ClearDateFilter"
        :FilterByDate="FilterByDate"
        :Apply="Apply"
        :Reset="Reset"
        :From="From"
        :key="reinitFilter"
        :To="To"
        :BackBtn="BackBtn"
        :Required="Required"
        :SortByDate="SortByDate"
        :FilterType="FilterType"
        :Ascending="Ascending"
        :Descending="Descending"
        :SurveyAssignToMe="SurveyAssignToMe"
        :SurveyMoreFilter="SurveyMoreFilter"
      />
      <div class="generic-loader filter-loader" v-if="apiCallLoader">
        <img src="../../../Assets/Images/spinner.svg" />
      </div>
    </div>
    <div class="col-sm-9 col-lg-9 tablet-full-width">
      <div class="accordion-wrapper">
        <h3 v-if="noDataMsg" class="empty-msg">
          {{ noResultMesg }}
        </h3>
        <!--loader-->
        <div class="generic-loader" v-show="isAjaxLoading">
          <img src="../../../Assets/Images/spinner.svg" />
        </div>
        <div v-if="filteredData.length != 0">
          <trainingCard
            :trainingArr="filteredData"
            :trainingObj="trainingObj"
            :OpenStatus="OpenStatus"
            :ClosedStatus="ClosedStatus"
          ></trainingCard>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import filterservice from "../GenericPageComponent/Filter/FilterService.vue";
import trainingCard from "../GenericListingComponent/TrainingBlock/TrainingCard.vue";

import axios from "axios";
let baseUrl = document.location.origin;
let apiUrl = baseUrl + "";
let language = window.CurrentLanguage.CurrentLanguage;
export default {
  components: {
    filterservice,
    trainingCard,
  },
  data() {
    return {
      pageNumber: 1,
      isAjaxLoading: true,
      filteredData: [],
      info: null,
      infoData: null,
      reinitFilter: 0,
      tarckApplyFilter: false,
      surveys: true,
      assignToMe: false,
      apiCallLoader: false,
      noResultMesg: null,
      noDataMsg: false,
      trainingObj: {},
      datestart: null,
      dateend: null,
    };
  },
  props: [
    "Status",
    "SectorLabel",
    "CategoryLabel",
    "ProductsLabel",
    "FunctionsLabel",
    "SearchLabel",
    "SearchPlaceHolder",
    "PageType",
    "tabs",
    "ClearDateFilter",
    "FilterByDate",
    "From",
    "To",
    "Required",
    "NoResultMessage",
    "NoResultMessageLoginRequired",
    "CategoriesOfRules",
    "Download",
    "Apply",
    "Reset",
    "ServiceCost",
    "CentralAdministration",
    "PublicAdministration",
    "Specialization",
    "Cosmetic",
    "SecondaryCategory",
    "Category",
    "BackBtn",
    "SortByDate",
    "FilterType",
    "Ascending",
    "Descending",
    "SurveyStatus",
    "SurveyStartDate",
    "SurveyFunction",
    "SurveySector",
    "SurveyResponse",
    "SurveyEndDate",
    "SurveyHealthProduct",
    "SurveyDescription",
    "SurveyAssignToMe",
    "SurveyMoreFilter",
    "Type",
    "OpenStatus",
    "ClosedStatus"
  ],

  methods: {
    getData() {
      this.noDataMsg = false;
      this.isAjaxLoading = true;
      this.infoData = [];

      if (this.tarckApplyFilter) {
        this.pageNumber = 1;
        this.filteredData = [];
        if (window.innerWidth > 1025) {
          this.apiCallLoader = true;
        }
      }

      if (this.searchClicked || this.tarckApplyFilter) {
        this.pageNumber = 1;
        this.filteredData = [];
      }

      let header = localStorage.getItem("token");
      let headers = {
        headers: { Authorization: `Bearer ${header}` },
      };
      let body = {
        PageType: "trainingListPage",
        PageNumber: this.pageNumber,
        DateFrom: this.datestart,
        DateTo: this.dateend,
        HealthProducts: this.healthArr,
        Functions: this.funcArr,
        Sectors: this.sectorArr,
        SortType: this.SortType,
        AssignedToMe: this.assignToMe,
      };

      axios
        .post(`${apiUrl}/Umbraco/Surface/Generic/ApplyFilters?culture=${language}`, body, headers)
        .then((response) => {
          this.apiCallLoader = false;
          this.searchClicked = false;
          this.infoData = response.data;
          this.tarckApplyFilter = false;
          this.isAjaxLoading = false;
            if (!header && body.AssignedToMe) {
                this.noResultMesg = this.NoResultMessageLoginRequired;
            } else {
                this.noResultMesg = this.NoResultMessage;
            }

          if (this.infoData.length != 0) {
            this.slice();
          } else {
            if (this.filteredData.length != 0) {
              this.noDataMsg = false;
            } else {
              this.noDataMsg = true;
            }
          }
        });
    },
    getFilterData() {
      this.isAjaxLoading = true;
      this.noDataMsg = false;
      axios
        .post(`${apiUrl}/Umbraco/Surface/Generic/GetAllFilters?culture=${language}`)
        .then((response) => {
          this.info = response.data;
          if (this.info.Sectors != null) {
            for (let item of this.info.Sectors) {
              this.$set(item, "checked", false);
              item.Department = item.Department.map((str, index) => ({
                value: str,
                id: index + 1,
                checked: false,
              }));
            }
          }
          if (this.info.HealthProducts != null) {
            for (let item of this.info.HealthProducts) {
              this.$set(item, "checked", false);
            }
          }
          if (this.info.Functions != null) {
            for (let item of this.info.Functions) {
              this.$set(item, "checked", false);
            }
          }
        });
    },
    slice() {
      this.filteredData = this.filteredData.concat(this.infoData);
    },
    checkTrigger() {
      setTimeout(() => {
        const options = {
          threshold: 0.1,
        };
        const checker = document.querySelector(".footer");
        const infiniteScroll = (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              if (this.infoData.length != 0) {
                this.isAjaxLoading = true;
                if (window.innerWidth > 1025) {
                  this.apiCallLoader = true;
                }
                setTimeout(() => {
                  this.pageNumber += 1;
                  this.getData();
                  this.isAjaxLoading = false;
                }, 500);
              }
            }
          });
        };

        const observer = new IntersectionObserver(infiniteScroll, options);
        observer.observe(checker);
      }, 1000);
    },
  },
  beforeMount() {
    this.getFilterData();
  },
  mounted() {
    this.getData();

    this.checkTrigger();
    this.trainingObj = {
      Status: this.Status,
      SectorLabel: this.SectorLabel,
      CategoryLabel: this.CategoryLabel,
      ProductsLabel: this.ProductsLabel,
      FunctionsLabel: this.FunctionsLabel,
      From: this.From,
      To: this.To,
      Type: this.Type,
    };
  },
};
</script>

<style></style>
